import React from 'react';
import { cn } from '@/lib/utils';
import { Spinner } from './spinner';

interface LoadingProps {
  className?: string;
  size?: 'small' | 'medium' | 'large';
}

export function Loading({ className, size = 'medium' }: LoadingProps) {
  return (
    <div className={cn('flex min-h-[400px] items-center justify-center', className)}>
      <Spinner size={size} />
    </div>
  );
}
